var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgVolumeEmpty = function SvgVolumeEmpty(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 10.5v-3a.75.75 0 0 1 .75-.75h1.345c.1 0 .195-.04.265-.11l2.36-2.36a.75.75 0 0 1 1.28.53v8.38a.75.75 0 0 1-1.28.53l-2.36-2.36a.375.375 0 0 0-.265-.11H6.75A.75.75 0 0 1 6 10.5Z"
  })));
};
export default SvgVolumeEmpty;